export default {
    // Add to your translation files (create src/i18n/locales/en/birth-chart.js)

// Header Section
"birth_chart_generator": "జన్మ కుండలి జనరేటర్",
"create_your": "మీ జన్మజాతకాన్ని సృష్టించే",
"birth_chart": "అద్భుతమైన మార్గం",
"kundli_analysis": "మరియు కుండలి విశ్లేషణ",
"birth_chart_description": "మీ ఖచ్చితమైన జన్మ వివరాల ఆధారంగా వివరణాత్మక గ్రహ స్థానాలు, భవిష్యవాణులు మరియు పరిహార పరిష్కారాలతో మీ వ్యక్తిగత వేద జన్మజాతకం రూపొందించబడుతుంది.",

// Form Fields
"enter_birth_details": "మీ జన్మ వివరాలను నమోదు చేయండి",
"full_name": "పూర్తి పేరు",
"enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
"gender": "లింగం",
"male": "పురుషుడు",
"female": "స్త్రీ", 
"other": "ఇతర",
"date_of_birth": "జన్మ తేదీ",
"time_of_birth": "జన్మ సమయం",
"exact_time_note": "ఖచ్చితమైన భవిష్యవాణుల కోసం సరైన జన్మ సమయం అత్యవసరం",
"place_of_birth": "జన్మ స్థలం",
"place_of_birth_placeholder": "నగరం, రాష్ట్రం, దేశం",
"place_birth_note": "ఖచ్చితమైన గణనల కోసం పూర్తి జన్మ స్థలాన్ని నమోదు చేయండి",

// Chart Options
"chart_type": "కుండలి రకం",
"south_indian_style": "దక్షిణ భారతీయ శైలి",
"north_indian_style": "ఉత్తర భారతీయ శైలి", 
"east_indian_style": "తూర్పు భారతీయ శైలి",

// Actions
"generate_birth_chart": "జన్మ కుండలిని రూపొందించండి",
"generating_chart": "కుండలిని రూపొందిస్తున్నది",
"download_chart": "కుండలిని డౌన్‌లోడ్ చేయండి",
"view_detailed_report": "వివరణాత్మక నివేదికను చూడండి",

// Features
"what_you_get": "మీరు పొందేవి",
"detailed_planetary_positions": "వివరణాత్మక గ్రహ స్థానాలు",
"zodiac_sign_analysis": "రాశి చక్ర విశ్లేషణ",
"dasha_system_predictions": "దశా వ్యవస్థ భవిష్యవాణులు", 
"remedial_suggestions": "పరిహార సూచనలు",

// Visual Elements
"sample_birth_chart": "నమూనా జన్మ కుండలి",
"sample_chart_description": "ఇది మీ వ్యక్తిగత జన్మ కుండలి ఎలా కనిపిస్తుందో చూపిస్తుంది",
"astrological_elements": "జ్యోతిష్య అంశాలు",

// Planets
"sun": "సూర్యుడు",
"moon": "చంద్రుడు",
"mars": "అంగారకుడు",
"mercury": "బుధుడు",
"jupiter": "గురువు",
"venus": "శుక్రుడు",

// Results
"your_birth_chart": "మీ జన్మ కుండలి",
"chart_generated_successfully": "కుండలి విజయవంతంగా రూపొందించబడింది!",
"chart_ready_message": "వివరణాత్మక విశ్లేషణ మరియు భవిష్యవాణులతో మీ వ్యక్తిగత జన్మ కుండలి సిద్ధంగా ఉంది."
}
